var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M10.6237 9.28165L12.2455 7.39942L7.97882 7.39648L9.77032 9.34534L9.77032 12.5908L6.97754 15.3658L13.3775 15.3758L10.6237 12.6129L10.6237 9.28165Z",
          fill: "#FF5050",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3.24414 2.90247C3.24414 2.60792 3.48292 2.36914 3.77747 2.36914H16.5775C16.872 2.36914 17.1108 2.60792 17.1108 2.90247V5.03581C17.1108 5.33036 16.872 5.56914 16.5775 5.56914H3.77747C3.48292 5.56914 3.24414 5.33036 3.24414 5.03581V2.90247ZM4.31081 3.43581V4.50247H16.0441V3.43581H4.31081Z",
          fill: "#647491",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3.24414 15.7033C3.24414 15.4087 3.48292 15.1699 3.77747 15.1699H16.5775C16.872 15.1699 17.1108 15.4087 17.1108 15.7033V17.8366C17.1108 18.1311 16.872 18.3699 16.5775 18.3699H3.77747C3.48292 18.3699 3.24414 18.1311 3.24414 17.8366V15.7033ZM4.31081 16.2366V17.3033H16.0441V16.2366H4.31081Z",
          fill: "#647491",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M4.49433 4.58746C4.74169 4.42755 5.07185 4.49843 5.23177 4.74579L8.6451 10.0255C8.75903 10.2018 8.75903 10.4284 8.6451 10.6046L5.23177 15.8844C5.07185 16.1317 4.74169 16.2026 4.49433 16.0427C4.24697 15.8828 4.17608 15.5526 4.336 15.3053L7.56214 10.3151L4.336 5.32491C4.17608 5.07755 4.24697 4.74738 4.49433 4.58746Z",
          fill: "#647491",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M15.8998 4.58746C16.1472 4.74738 16.218 5.07755 16.0581 5.32491L12.832 10.3151L16.0581 15.3053C16.218 15.5526 16.1472 15.8828 15.8998 16.0427C15.6524 16.2026 15.3223 16.1317 15.1624 15.8844L11.749 10.6046C11.6351 10.4284 11.6351 10.2018 11.749 10.0255L15.1624 4.74579C15.3223 4.49843 15.6524 4.42755 15.8998 4.58746Z",
          fill: "#647491",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }